module.exports = __webpack_public_path__ + "posture/static/img/head_sideway_right.e5601a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/head_sideway_right.png
// module id = eBau
// module chunks = 1